import { formatDate } from '@/filters';

// 系统名称
const systemName = '巴斯夫安全管理平台';

// 接口地址
const baseURL = process.env.VUE_APP_IFDEBUG === 'true' ? '/paasapi' : process.env.VUE_APP_API_PATH;

const date = new Date();

// 今天
const today = formatDate(date);

// 时间戳
const timestamp = 3600 * 1000 * 24;

// 昨天
const yesterday = formatDate(date.getTime() - timestamp);

// 最近一个月
let lastMonthDay = new Date();
lastMonthDay.setTime(lastMonthDay.getTime() - timestamp * 30);
lastMonthDay = formatDate(lastMonthDay);

// 每月1号
let startDay = new Date();
startDay.setTime(new Date(startDay.getFullYear(), startDay.getMonth(), 1));
startDay = formatDate(startDay);

// 本月
const currentMonth = formatDate(date, 'yyyy-MM');

// 最近一年
let lastYearDay = new Date();
lastYearDay.setTime(lastYearDay.getTime() - timestamp * 365);
lastYearDay = formatDate(lastYearDay);

// 时间范围快捷选项配置
const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const start = new Date();
        start.setTime(start.getTime() - timestamp * 7);
        picker.$emit('pick', [start, date]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const start = new Date();
        start.setTime(start.getTime() - timestamp * 30);
        picker.$emit('pick', [start, date]);
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const start = new Date();
        start.setTime(start.getTime() - timestamp * 90);
        picker.$emit('pick', [start, date]);
      }
    }
  ]
};

// 禁用当前时间之前的时间配置
const disabledBeforePickerOptions = {
  disabledDate(time) {
    return time.getTime() < Date.now() - 8.64e6;
  }
};

// 禁用当前时间之后的时间配置
const disabledAfterPickerOptions = {
  disabledDate(time) {
    return time.getTime() > Date.now() - 8.64e6;
  }
};

// 白名单
const whiteList = [
  '/',
  '/home/index',
  '/home/application',
  '/home/login',
  '/403',
  '/404',
  '/500'
];

// token存储key
const tokenKey = 'token';

// 用户信息存储key
const userKey = 'user';

// 分页存储key
const pageKey = 'page';

// 搜索存储key
const searchKey = 'search';

export {
  baseURL,
  systemName,
  today,
  timestamp,
  yesterday,
  lastMonthDay,
  lastYearDay,
  startDay,
  currentMonth,
  pickerOptions,
  disabledBeforePickerOptions,
  disabledAfterPickerOptions,
  whiteList,
  tokenKey,
  userKey,
  pageKey,
  searchKey
};
